var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6949 22.1213C37.3044 22.5118 36.6712 22.5118 36.2807 22.1213L20.6152 6.45585C20.2247 6.06532 19.5915 6.06532 19.201 6.45585L3.53554 22.1213C3.14502 22.5118 2.51185 22.5118 2.12133 22.1213L0.707113 20.7071C0.316589 20.3166 0.316589 19.6834 0.707113 19.2929L17.7868 2.21321C18.9584 1.04163 20.8579 1.04163 22.0294 2.2132L39.1091 19.2929C39.4997 19.6834 39.4997 20.3166 39.1091 20.7071L37.6949 22.1213Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarretUp);
export default __webpack_public_path__ + "static/media/icon_carret-Up.1abb3b099600160dca4feced19b4bbef.svg";
export { ForwardRef as ReactComponent };